import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { MarketBanner } from '@market/react';

const OutOfStockBanner = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { cart } = props;

  const oos = cart.flatMap((cartItem) =>
    cartItem.out_of_stock ? (
      <li key={cartItem.id} className="paragraph-30">
        {cartItem.product_variant.title}
      </li>
    ) : (
      []
    ),
  );

  if (oos.length === 0) {
    return null;
  }

  return (
    <MarketBanner variant="critical" style={{ margin: theme.spacing(2, 0) }}>
      <p className="medium-30">
        {t('checkout.shippingEstimate.outOfStockNotice.text')}
      </p>
      <ul style={{ listStyleType: 'disc', paddingLeft: theme.spacing(1.5) }}>
        {oos}
      </ul>
    </MarketBanner>
  );
};

export default OutOfStockBanner;
